import { useEffect, useState } from "react";

function getSavedName(name, initialName) {
    const savedName = JSON.parse(localStorage.getItem(name));
    if(savedName){
        return savedName
    }else{
        return initialName;
    }
}



export default function UseLocalStorage(name,initialName) {
    let [value, setValue] = useState(() =>{
       return getSavedName(name,initialName);
    });

    useEffect(() => {
        localStorage.setItem(name,JSON.stringify(value));
    },[value,name]);
    
    return [value, setValue];


}


